import { useT } from '_metronic/i18n/Metronici18n'
import { IconPaths, ModalSize } from '../../../../../../../_metronic/helpers'
import { Button, useModal } from '../../../../../../components'
import { EmpresasClienteModal } from '../modal/EmpresasClienteModal'

const EmpresasClienteListToolbar = () => {
  const { showModal } = useModal()
  const { t } = useT()
  const openAddEmpresa = () => {
    showModal({
      title: 'Empregador ASO',
      content: <EmpresasClienteModal />,
      size: ModalSize.Medium,
    })
  }

  return (
    <Button className='btn-primary' icon={IconPaths.Add} onClick={openAddEmpresa}>
      {t('common.add')}
    </Button>
  )
}

export { EmpresasClienteListToolbar }
